export default {
  //isBackend: false,
  isBackend: true,
  auth: {
    username: '',
    password: ''
  }
};
